<template lang="pug">
  div.cover-w
    div.cover-w-content
      label.fp-close(@click='$emit("close")')
        img(src='/static/login/images/btn_close.png')
      dl
        dt
          img(src='/static/login/images/logo.png' alt='kami')
        dd.f24.text-ct(:class="{[type]:true}") {{ title }}
        dd.f24.text-ct.importantTip(v-show="tip") {{ tip }}
      //- 分步骤
      div.fp-formBox
        slot
</template>

<script>
export default {
  name: 'cover',
  data () {
    return {
      title: '',
      type: 'normal',
      tip: ''
    }
  },
  methods: {
  },
  created () {
    this.$on('changetitle', (event, type) => {
      this.title = event
      this.type = type
    })
    this.$on('changetip', (event, tip) => {
      this.tip = event
    })
    document.body.classList.add('overflow_hidden')
  },
  destroyed() {
    document.body.classList.remove('overflow_hidden')
  }
}
</script>

<style lang='less' scoped>
.cover-w-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .fp-close {
    position: absolute;
    top: 50px;
    right: 70px;
    cursor: pointer;
  }

  dl {
    padding-top: 130px;
    margin-bottom: 45px;

    dt {
      margin-bottom: 26px;
      text-align: center;
    }

    dd {
      line-height: 30px;
    }
  }


  .fp-formBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }

  .text-ct.success{
    color:#24cc7c
  }

  .importantTip{
    color: #ff6666;
    margin-top: 20px;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/components/cover.vue